import React from 'react';
import { IMfrmBuyboxConfig } from "..";
import {
    ContentEditableEvent,
    IRequestContext,
    Text
} from '@msdyn365-commerce/core';
import { Node } from '@msdyn365-commerce-modules/utilities';

export const BuyboxCallChat = (props: {config: IMfrmBuyboxConfig, requestContext: IRequestContext}): JSX.Element => {
    const {config, requestContext} = props;
    const telOnClick = () => {
        window.location.href = `tel:+${config.callChatPhoneNumber}`;
    };

    const toggleChatClick = () => {
        // tslint:disable: no-function-expression
        // tslint:disable: typedef
        setTimeout(function () {
            // eslint-disable-next-line no-eval, security/detect-eval-with-expression
            eval(
                `var elems = document.querySelectorAll('.uiButton.helpButtonEnabled, .minimizedContainer.helpButton, .sidebarHeader.minimizedContainer'); if(elems != undefined && elems.length > 0) { if(elems.length > 1){elems[1].click()} else {elems[0].click()}}`
            );
        }, 1000);
        // @ts-ignore
        if ('utag' in window) {
            // @ts-ignore
            // tslint:disable-next-line: object-literal-key-quotes
            utag.link({
                event: 'chat-widget-initiated',
                event_type: 'chat_click',
                event_category: 'chat',
                event_action: 'click',
                event_label: 'chat engagement'
            });
        }
    };

    const onTextChange = (event: ContentEditableEvent) => (config.callChatMessage = event.target.value);
    return (
        <Node className='ms-buybox__call-chat-container'>
            <Node className='call-chat__info-message'>
                <Text
                    className='call-chat__info-message-text'
                    text={config.callChatMessage}
                    editProps={{ onEdit: onTextChange, requestContext: requestContext }}
                />
            </Node>
            <Node className='call-chat-buttons'>
                <button className='call-chat__call-button' onClick={telOnClick}>
                    Call
                </button>
                <button className='call-chat__chat-button' onClick={toggleChatClick}>
                    Chat
                </button>
            </Node>
        </Node>
    );
};